import { createRouter } from "@tanstack/react-router";
import { t } from "i18next";

import { queryClient } from "@/lib/query";
import type { Tenant } from "@/types";

import AccessDenied from "../components/errors/AccessDenied";
import ErrorComponent from "../components/errors/ErrorComponent";
import NotFound from "../components/errors/NotFound";
import { routeTree } from "../routeTree.gen";
import { isHttpError } from "../utils/permissions";

export const router = createRouter({
  routeTree,
  defaultErrorComponent: ({ error }) => {
    if (isHttpError(error)) {
      if (error.statusCode === 403) {
        return <AccessDenied />;
      }
      if (error.statusCode === 404) {
        return <NotFound />;
      }
    }
    return <ErrorComponent error={error} />;
  },
  context: {
    queryClient,
    t,
    tenant: null as unknown as Tenant,
  },
  // defaultPendingMinMs: 2000,
  defaultNotFoundComponent: () => {
    return <NotFound />;
  },
  // defaultPreload: "intent",
  // defaultPreloadStaleTime: 0,
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
  interface StaticDataRouteOption {
    admin?: boolean;
  }
}
